import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ModuloGuard } from './guards/compartidos/modulo.guard';
import { UsuarioGuard } from './guards/compartidos/usuario.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'log-in',
    pathMatch: 'full'
  },
  {
    path: 'log-in',
    loadChildren: () => import('./pages/log-in/log-in.module')
      .then(m => m.LogInPageModule)
  },
  {
    path: 'AjustesPage',
    loadChildren: () => import('./pages/ajustes/ajustes.module')
      .then(m => m.AjustesPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultPage',
    loadChildren: () => import('./pages/default/default.module')
      .then(m => m.DefaultPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultMaestroProductosPage',
    loadChildren: () =>
      import('./pages/maestroProductos/default-productos/default-productos.module')
        .then(m => m.DefaultProductosPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultarribosPage',
    loadChildren: () => import('./pages/arribos/default-arribos/default-arribos.module')
      .then(m => m.DefaultArribosPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'MovimientosinventarioPage',
    loadChildren: () => import('./pages/entrada/herramientas/default-movimientos/default-movimientos.module')
      .then(m => m.DefaultMovimientosPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultsalidasPage',
    loadChildren: () => import('./pages/salidas/listado/general-salidas/general-salidas.module')
      .then(m => m.GeneralSalidasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashEntradasMainTabsPage',
    loadChildren: () => import('./pages/entrada/ReporteEntrada/tab-general-entrada/tab-general-entrada.module')
      .then(m => m.TabGeneralEntradaPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultpendientesPage',
    loadChildren: () => import('./pages/tareasPendientes/listado/general-tareas-pendientes/general-tareas-pendientes.module')
      .then(m => m.GeneralTareasPendientesPageModule),
    // .then(m => m.DefaultTareasPendientesPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  // {
  //   path: 'DashInventarioMainTabsPage',
  //   loadChildren: () => import('./pages/inventario/reporteInventarioGraficos/tab-inventario-main-tabs/tab-inventario-main-tabs.module')
  //     .then(m => m.TabInventarioMainTabsPageModule),
  //   canLoad: [UsuarioGuard],
  //   canActivate: [ModuloGuard]
  // },
  {
    path: 'DefaultauditoriaPage',
    loadChildren: () => import('./pages/salidas/listado/general-auditoria/general-auditoria.module')
      .then(m => m.GeneralAuditoriaPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultcontrolllegadasPage',
    loadChildren: () => import('./pages/controlDeLlegadas/listado/general-llegadas/general-llegadas.module')
      .then(m => m.GeneralLlegadasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashSalidasMainTabsPage',
    loadChildren: () => import('./pages/salidas/ReporteSalidas/tab-general-salidas/tab-general-salidas.module')
      .then(m => m.TabGeneralSalidasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashCierreMensualTabsPage',
    loadChildren: () => import('./pages/cierreMensual/ReporteCierreMensual/tab-general-cierre-mensual/tab-general-cierre-mensual.module')
      .then(m => m.TabGeneralCierreMensualPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashRotacionInventarioTabsPage',
    loadChildren: () => import('./pages/inventario/ReporteRotacionInventario/tab-general-rotacion/tab-general-rotacion.module')
      .then(m => m.TabGeneralRotacionPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashReabastoTabsPage',
    loadChildren: () => import('./pages/reabasto/ReporteReabasto/tab-general-reabasto/tab-general-reabasto.module')
      .then(m => m.TabGeneralReabastoPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashInventarioGeneralPage',
    loadChildren: () => import('./pages/inventario/ReporteInventario/tab-general-inventario/tab-general-inventario.module')
      .then(m => m.TabGeneralInventarioPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashSalidasBtmPage',
    loadChildren: () => import('./pages/salidas/pizarronDeSalidas/tab-general-pizarron/tab-general-pizarron.module')
      .then(m => m.TabGeneralPizarronPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'pizarronDePresurtido',
    loadChildren: () => import('./pages/presurtido/pizarron-de-presurtido/pizarron-de-presurtido.module')
      .then(m => m.PizarronDePresurtidoPageModule),
    canLoad: [UsuarioGuard]
  },
  {
    path: 'ListacatcatalogoPage',
    loadChildren: () => import('./pages/sistema/catalogos/default-catalogos/default-catalogos.module')
      .then(m => m.DefaultCatalogosPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'ConfiguracionClientesPage',
    loadChildren: () => import('./pages/sistema/configuracion/cuentas/listado/general/general.module')
      .then(m => m.GeneralPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'tracking-paqueteria/:data',
    loadChildren: () => import('./pages/salidas/publico/tracking-paqueteria/tracking-paqueteria.module')
      .then(m => m.TrackingPaqueteriaPageModule)
  },
  {
    path: 'PivoteSalidas',
    loadChildren: () => import('./pages/salidas/listado/pivote-salidas/pivote-salidas.module')
      .then(m => m.PivoteSalidasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashAuditoriaMainTabsPage',
    loadChildren: () => import('./pages/inventario/AuditoriaInventario/listado/general-auditorias/general-auditorias.module')
      .then(m => m.GeneralAuditoriasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'pizarron-salidas/:data',
    loadChildren: () => import('./pages/salidas/publico/pizarron-salidas-publico/pizarron-salidas-publico.module')
      .then(m => m.PizarronSalidasPublicoPageModule)
  },
  {
    path: 'DevolucionesSalidas',
    loadChildren: () => import('./pages/salidas/listado/general-devoluciones/general-devoluciones.module')
      .then(m => m.GeneralDevolucionesPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'GeneralPlantillasPage',
    loadChildren: () => import('./pages/plantillas/listado/general-plantillas/general-plantillas.module')
      .then(m => m.GeneralPlantillasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'PanelTareasPage',
    loadChildren: () => import('./pages/sistema/configuracion/tareasProgramadas/panel-tareas/panel-tareas.module')
      .then(m => m.PanelTareasPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'KpiPage',
    loadChildren: () => import('./pages/tableros/kpi/kpi.module')
      .then(m => m.KpiPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'KpiEcommPage',
    loadChildren: () => import('./pages/tableros/kpiEcomm/kpi.module')
      .then(m => m.KpiPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'KpiRetailPage',
    loadChildren: () => import('./pages/tableros/kpiRetail/kpi.module')
      .then(m => m.KpiPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashUsuariosMainTabsPage',
    loadChildren: () => import('./pages/sistema/configuracion/usuarios/listado/general-usuarios/general-usuarios.module')
      .then(m => m.GeneralUsuariosPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashPerfilesUsuarios',
    loadChildren: () => import('./pages/sistema/configuracion/perfiles/listado/general-perfiles/general-perfiles.module')
      .then(m => m.GeneralPerfilesPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'terminosCondiciones',
    loadChildren: () => import('./pages/sistema/terminos-condiciones/terminos-condiciones.module')
      .then(m => m.TerminosCondicionesPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashArribosMainTabsPage',
    loadChildren: () => import('./pages/arribos/ReporteArribo/tab-general-arribo/tab-general-arribo.module')
      .then(m => m.TabGeneralArriboPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DashSalidasPaqueteriaPage',
    loadChildren: () => import('./pages/salidas/listado/dash-salidas-paqueteria-page/dash-salidas-paqueteria-page.module')
      .then(m => m.DashSalidasPaqueteriaPagePageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'NotificacionesWms',
    loadChildren: () => import('./pages/sistema/notificaciones/notificaciones-wms/notificaciones-wms.module')
      .then(m => m.NotificacionesWmsPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'ArchivosLocales',
    loadChildren: () => import('./pages/archivos/listado/ver-archivos-locales/ver-archivos-locales.module')
      .then(m => m.VerArchivosLocalesPageModule),
    canLoad: [UsuarioGuard]
  },
  {
    path: 'GeneralPresurtidoPage',
    loadChildren: () => import('./pages/presurtido/listado/general-presurtido/general-presurtido.module')
      .then(m => m.GeneralPresurtidoPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'DefaultTareasAgrupadas',
    loadChildren: () => import('./pages/tareasPendientes/listado/general-tareas-agrupadas/general-tareas-agrupadas.module')
      .then(m => m.GeneralTareasAgrupadasPageModule),
    canLoad: [UsuarioGuard]
  },
  {
    path: 'DashHistorialMercanciaPage',
    loadChildren: () => import('./pages/inventario/ReporteHistorialMercancia/general/general.module')
    .then( m => m.GeneralPageModule),
    canLoad: [UsuarioGuard]
  },
  {
    path: 'InventarioPorUbicacion',
    loadChildren: () => import('./pages/inventario/UbicacionDeProductos/ubicacion-de-productos.module')
    .then( m => m.UbicacionDeProductosPageModule),
    canLoad: [UsuarioGuard]
  },{
    path: 'InventarioPorProducto',
    loadChildren: () => import('./pages/inventario/inventario-por-producto/inventario-por-producto.module')
    .then( m => m.InventarioPorProductoPageModule),
    canLoad: [UsuarioGuard]
  },
  {
    path: 'InventarioPorSKU',
    loadChildren: () => import('./pages/inventario/inventario-por-sku/inventario-por-sku.module')
    .then( m => m.InventarioPorSkuPageModule),
    canLoad: [UsuarioGuard],
    canActivate: [ModuloGuard]
  },
  {
    path: 'pizarron-de-presurtido',
    loadChildren: () => import('./pages/presurtido/pizarron-de-presurtido/pizarron-de-presurtido.module').then( m => m.PizarronDePresurtidoPageModule)
  },
  {
    path: 'inventario-por-producto',
    loadChildren: () => import('./pages/inventario/inventario-por-producto/inventario-por-producto.module').then( m => m.InventarioPorProductoPageModule)
  },
  {
    path: 'consolidacion-lpn',
    loadChildren: () => import('./pages/entrada/herramientas/consolidacion-lpn/consolidacion-lpn.module').then( m => m.ConsolidacionLPNPageModule)
  }



];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      relativeLinkResolution: 'legacy'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
